import store from "@store/index";

const mixin = {
  data: function () {
    return {
      get todasAsAssociacoes() {
        return store.getters.hasPermission("todas as associacoes");
      },
      get todasAsEntidades() {
        return store.getters.hasPermission("todas as entidades");
      },
      get todosOsParceiros() {
        return store.getters.hasPermission("todos os parceiros");
      },
      get podeEditarTodasInfosContrato() {
        return store.getters.hasPermission(
          "pode editar todas infos do contrato"
        );
      },
      get podeEnviarDocumentosParaAnalise() {
        return store.getters.hasPermission(
          "pode enviar documentos para analise"
        );
      }
    };
  }
};

export default mixin;
